(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const searchOpenButton = document.querySelector(
      '[data-header-search-open]',
    );
    const searchOverlay = document.querySelector(
      '[data-header-search-overlay]',
    );
    const searchCloseButton = document.querySelector(
      '[data-header-search-close]',
    );
    const searchBackdrop = document.querySelector(
      '[data-header-search-backdrop]',
    );

    if (searchOpenButton && searchOverlay) {
      const setSearchOverlay = (open) => {
        searchOverlay.hidden = !open;
        searchOpenButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
        document.documentElement.style.overflow = open ? 'hidden' : '';

        if (open) {
          const searchInput = searchOverlay.querySelector(
            'input[type="search"]',
          );
          if (searchInput) {
            window.requestAnimationFrame(() => searchInput.focus());
          }
        }
      };

      setSearchOverlay(false);

      searchOpenButton.addEventListener('click', () => {
        const isOpen = !searchOverlay.hidden;
        setSearchOverlay(!isOpen);
      });

      if (searchCloseButton) {
        searchCloseButton.addEventListener('click', () =>
          setSearchOverlay(false),
        );
      }

      if (searchBackdrop) {
        searchBackdrop.addEventListener('click', () => setSearchOverlay(false));
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !searchOverlay.hidden) {
          setSearchOverlay(false);
        }
      });
    }

    const desktopButtons = document.querySelectorAll('[data-desktop-trigger]');
    const positionPanel = (button, panel) => {
      const panelOffset = 12;
      const nav = button.closest('nav');
      const navGroup = button.closest('[data-desktop-nav]');
      const navRect = nav ? nav.getBoundingClientRect() : null;
      const navGroupRect = navGroup ? navGroup.getBoundingClientRect() : null;
      const header = document.querySelector('header');
      const headerRect = header ? header.getBoundingClientRect() : null;

      if (panel.hasAttribute('data-mega-panel')) {
        const navRectSafe = navRect || button.getBoundingClientRect();
        panel.style.position = 'fixed';
        panel.style.left = '0';
        panel.style.right = '0';
        panel.style.transform = 'translateX(0)';
        panel.style.top = `${navRectSafe.bottom + panelOffset}px`;
        return;
      }

      const rect = button.getBoundingClientRect();
      const popWidth = panel.offsetWidth || 256;
      const preferredLeft = rect.left + rect.width / 2 - popWidth / 2;
      const viewportMin = 12;
      const viewportMax = window.innerWidth - popWidth - 12;
      const containerMin = navRect ? navRect.left : viewportMin;
      const containerMax = navRect ? navRect.right - popWidth : viewportMax;
      const minLeft = Math.max(viewportMin, containerMin);
      const maxLeft = Math.min(viewportMax, containerMax);
      const left =
        maxLeft >= minLeft
          ? Math.min(Math.max(preferredLeft, minLeft), maxLeft)
          : Math.max(viewportMin, preferredLeft);
      panel.style.position = 'fixed';
      panel.style.left = `${left}px`;
      panel.style.transform = 'translateX(0)';
      const anchorTop = navGroupRect
        ? navGroupRect.bottom
        : navRect
          ? navRect.bottom
          : headerRect
            ? headerRect.bottom
            : rect.bottom;
      panel.style.top = `${anchorTop + panelOffset}px`;
    };

    let rafId = null;
    const syncOpenPanels = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        document
          .querySelectorAll('[data-desktop-panel]:not([hidden])')
          .forEach((panel) => {
            const btn = document.querySelector(
              `button[popovertarget="${panel.id}"]`,
            );
            if (btn) positionPanel(btn, panel);
          });
      });
    };

    window.addEventListener('scroll', syncOpenPanels, { passive: true });
    window.addEventListener('resize', syncOpenPanels);

    desktopButtons.forEach((button) => {
      const targetId = button.getAttribute('popovertarget');
      const panel = targetId ? document.getElementById(targetId) : null;
      if (!panel) return;

      button.addEventListener('click', (event) => {
        event.preventDefault();

        const isPopover =
          panel.hasAttribute('popover') &&
          typeof panel.showPopover === 'function';
        const isOpen = isPopover
          ? panel.matches(':popover-open')
          : !panel.hasAttribute('hidden');

        document.querySelectorAll('[data-desktop-panel]').forEach((other) => {
          if (other !== panel) {
            other.setAttribute('hidden', '');
            const otherBtn = document.querySelector(
              `button[popovertarget="${other.id}"]`,
            );
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          }
        });

        if (isPopover) {
          document.querySelectorAll('el-popover[popover]').forEach((other) => {
            if (other !== panel && other.matches(':popover-open')) {
              other.hidePopover();
            }
          });
        }

        if (isOpen) {
          if (isPopover) {
            panel.hidePopover();
          } else {
            panel.setAttribute('hidden', '');
          }
          button.setAttribute('aria-expanded', 'false');
        } else {
          if (isPopover) {
            panel.showPopover();
          } else {
            panel.removeAttribute('hidden');
          }
          positionPanel(button, panel);
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (
        event.target.closest('[data-desktop-nav]') ||
        event.target.closest('[data-desktop-panel]')
      )
        return;

      document.querySelectorAll('[data-desktop-panel]').forEach((panel) => {
        panel.setAttribute('hidden', '');
        const btn = document.querySelector(
          `button[popovertarget="${panel.id}"]`,
        );
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });

      document.querySelectorAll('el-popover[popover]').forEach((pop) => {
        if (pop.matches(':popover-open')) {
          pop.hidePopover();
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('[data-desktop-panel]').forEach((panel) => {
        panel.setAttribute('hidden', '');
        const btn = document.querySelector(
          `button[popovertarget="${panel.id}"]`,
        );
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });

      document.querySelectorAll('el-popover[popover]').forEach((pop) => {
        if (pop.matches(':popover-open')) {
          pop.hidePopover();
        }
      });
    });

    const disclosures = document.querySelectorAll('el-disclosure');
    disclosures.forEach((disclosure) => {
      const button = disclosure.querySelector('button[commandfor]');
      const content = disclosure.querySelector('div[hidden]');

      if (button && content) {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const isHidden = content.hasAttribute('hidden');
          const icon = button.querySelector('svg');

          if (isHidden) {
            content.removeAttribute('hidden');
            if (icon) icon.classList.add('rotate-180');
          } else {
            content.setAttribute('hidden', '');
            if (icon) icon.classList.remove('rotate-180');
          }
        });
      }
    });

    const mobileMenu = document.getElementById('mobile-menu');
    if (mobileMenu) {
      const setBodyScrollLocked = (locked) => {
        document.body.style.overflow = locked ? 'hidden' : '';
        document.documentElement.style.overflow = locked ? 'hidden' : '';
      };

      mobileMenu.addEventListener('toggle', () => {
        const isOpen = mobileMenu.matches(':popover-open');
        setBodyScrollLocked(isOpen);
      });

      mobileMenu.addEventListener('click', (event) => {
        if (event.target === mobileMenu) {
          mobileMenu.hidePopover();
        }
      });
    }
  });
})();
